export default __webpack_public_path__ + "static/sparkle-5f8c63d87c8cc302c85c997ba8fe0d76.mp3";